// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__C9PPS","purple":"Loader_purple__KT+IM","white":"Loader_white__LgEwB","loading":"Loader_loading__TG7uL"};